module.exports = __webpack_public_path__ + "static/media/medical-kit.e3002605.svg";